import React from "react";


export const handleInputChangeName = (event) => {
    const value = event.target.value;
  
    // Garde uniquement les lettres, apostrophes et tirets
    event.target.value = value.replace(/[^a-zA-ZÀ-ÿ'é_-\s]/g, '');
  };

  export const handleInputChangeAddress = (event) => {
    const value = event.target.value;
  
    // Garde lettres (avec accents), chiffres, espaces, apostrophes, tirets, points et virgules
    event.target.value = value.replace(/[^a-zA-ZÀ-ÿ0-9\s'.,\-]/g, '');
  };
  
  
  export const handleInputChangePieces = (event) => {
    let value = event.target.value;
  
    // Supprime tous les caractères sauf chiffres et séparateurs (point ou virgule)
    value = value.replace(/[^0-9.,]/g, '');
  
    // Remplace la virgule par un point pour normaliser
    value = value.replace(',', '.');
  
    // Ne garde qu’un seul point
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
  
    // Séparer partie entière et décimale
    let [integerPart, decimalPart] = value.split('.');
  
    // Limiter la partie entière à 8 chiffres
    if (integerPart.length > 8) {
      integerPart = integerPart.slice(0, 8);
    }
  
    // Limiter la partie décimale à 3 chiffres
    if (decimalPart && decimalPart.length > 3) {
      decimalPart = decimalPart.slice(0, 3);
    }
  
    // Reconstruire la valeur
    value = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
  
    // Mise à jour de l’input
    event.target.value = value;
  };
  
  
  export const handleInputChangePourcentage = (event) => {
    let value = event.target.value;
  
    // Supprime tous les caractères sauf chiffres et séparateurs (point ou virgule)
    value = value.replace(/[^0-9.,]/g, '');
  
    // Remplace la virgule par un point pour normaliser
    value = value.replace(',', '.');
  
    // Ne garde qu’un seul point
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
  
    // Séparer partie entière et décimale
    let [integerPart, decimalPart] = value.split('.');
  
    // Limiter la partie entière à 3 chiffres (pour pouvoir taper 100)
    if (integerPart.length > 3) {
      integerPart = integerPart.slice(0, 3);
    }
  
    // Limiter la partie décimale à 2 chiffres
    if (decimalPart && decimalPart.length > 2) {
      decimalPart = decimalPart.slice(0, 2);
    }
  
    // Reconstruire la valeur
    value = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    if (parseFloat(value) > 100) {
      value = '100';
    }
  
    // Mise à jour de l’input
    event.target.value = value;
  };

  export const handleInputChangeH = (event) => {
    let value = event.target.value;
  
    // Supprime tous les caractères sauf chiffres et séparateurs (point ou virgule)
    value = value.replace(/[^0-9.,]/g, '');
  
    // Remplace la virgule par un point pour normaliser
    value = value.replace(',', '.');
  
    // Ne garde qu’un seul point
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
  
    // Séparer partie entière et décimale
    let [integerPart, decimalPart] = value.split('.');
  
    // Limiter la partie entière à 3 chiffres
    if (integerPart.length > 3) {
      integerPart = integerPart.slice(0, 3);
    }
  
    // Limiter la partie décimale à 2 chiffres
    if (decimalPart && decimalPart.length > 2) {
      decimalPart = decimalPart.slice(0, 2);
    }
  
    // Reconstruire la valeur
    value = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
  
    // Mise à jour de l’input
    event.target.value = value;
  };

  export const handleInputChangeImmatriculation = (event) => {
    let value = event.target.value;

    value = value.replace(/[^A-Za-z0-9 -]/g, '');

    if (value.length > 15) {
        value = value.slice(0, 15);
    }
    value = value.replace(/\s+/g, ' ').trim();

    // Mise à jour de l’input
    event.target.value = value;
};


export const handleInputChangeNumber = (event) => {
    const value = event.target.value;
    
    // Ne garde que les chiffres et les points (optionnel)
    event.target.value = value.replace(/[^0-9.]/g, '');
  };
  